import React from 'react'

const AnimArrow = ({ color = '#FF0E1D' }) => {
  return (
    <svg width='27' height='27' viewBox='0 0 27 27' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M26.559 13.686L13.6083 0.831857L11.1811 3.12828L21.6548 12.6212L0.190063 11.8874L0.190063 15.4849L21.6531 14.7509L11.1811 24.6338L13.6083 26.9302L26.559 13.686Z' fill={color} />
    </svg>
  )
}

export default AnimArrow
